import { mainApiEndpoints } from 'api/endpoints';

export const getSupportMediaUrl = (filename) => {
  return mainApiEndpoints.supportMedia + '/' + filename;
};
